@if(service.viewDroplistItems.length){
<div class='experience-courses-views-part'>

	@if(service.selectedViewItem(); as selectedViewItem){

	<droplist class="views-droplist" [items]='service.viewDroplistItems' [selectedItem]='selectedViewItem'
		(selectionChange)='service.onViewDroplistChange($event)' [filterable]='false' [navigation]='true'
		sortBy='customSort' style='display:inline-block'>
	</droplist>

	@switch (selectedViewItem.uniqueId) {
	@case (service.viewId.Catalog) {
	<experience-courses-catalog-view-part></experience-courses-catalog-view-part>
	}
	@case (service.viewId.Monitoring) {
	<experience-courses-monitoring-view-part></experience-courses-monitoring-view-part>
	}
	@case (service.viewId.AcceleratorEnrollments) {
	<experience-courses-accelerator-enrollments-view-part></experience-courses-accelerator-enrollments-view-part>
	}
	@case (service.viewId.AcceleratorCourseFeedback) {
	<experience-courses-accelerator-course-feedback-view-part></experience-courses-accelerator-course-feedback-view-part>
	}
	}
	}

</div>
}